export default "__VITE_ASSET__DJVJH4ek__"